import Vue from 'vue';
import '@/plugins/pixel';
import cookies from 'vue-cookies';
import VueIntercom from '@mathieustan/vue-intercom';
import VueCryptoJS from 'vue-cryptojs';
import Vuelidate from 'vuelidate';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'vue-swatches/dist/vue-swatches.css';

Vue.use(cookies);
Vue.use(VueIntercom, { appId: 'app-vue' });
Vue.use(VueCryptoJS);
Vue.use(Vuelidate);
Vue.use(PerfectScrollbar, {
  options: {
    minScrollbarLength: 50,
    maxScrollbarLength: 150,
  },
});
